import React, { useContext, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { BuilderContext, useDrawer } from "react-flow-builder";
import {
  Row,
  Col,
  Input,
  Select,
  Tooltip,
  Button,
  Slider,
  InputNumber,
  Form,
} from "antd";
import { DeleteTwoTone, PlusCircleOutlined } from "@ant-design/icons";
import { notify } from "../../../../../../../components/Snack";
import { store } from "../../../../../../../redux";
import { setDraft } from "../../../../../../../redux/actions/skill";
import { getCollections } from "../../../../../../../redux/actions/collections";
import { getCollectionsV2 } from "../../../../../../../redux/actions/collectionsV2";

const { TextArea } = Input;
const { Option } = Select;

const RagConfig = (props) => {
  const [form] = Form.useForm();

  const dispatch = useDispatch();
  const [nodeData, setNodeData] = useState(null);

  const skill = useSelector((state) => state.skillReducer.trainDraft);
  const [modelName, setModelName] = useState("");
  const [userContent, setUserContent] = useState("");
  const [outputVariable, setOutputVariable] = useState("");
  const [collections, setCollections] = useState([]);

  const userDetails = useSelector((state) => state.organizationReducer.currentOrganization);
  const groupPlan = useSelector((state) => state.userReducer.groupPlan);

  let planType;
  if((groupPlan?.planId == 4)){
    planType = "team";
  } else if((groupPlan?.planId == 5)){
    planType = "business";
  } else{
    planType = "pro";
  }

  let orgFilterFlag = false;
  try{
    const orgIdToFilterList = process.env?.REACT_APP_FILTERED_ORG_IDS_COLLECTION
                              ? JSON.parse(process.env.REACT_APP_FILTERED_ORG_IDS_COLLECTION)
                              : [];
    orgFilterFlag = orgIdToFilterList?.includes(JSON.parse(userDetails?.id));
  } catch{
    orgFilterFlag = false;
  }

  useEffect(() => {
    setNodeData(props?.data);
    setModelName(props?.data?.collectionName);
    setUserContent(props?.data?.messages[0]?.content);
    setOutputVariable(props?.data?.variable);
    return () => {};
  }, [props?.data]);

  const onChangeGptModal = (value) => {
    setModelName(value);
  };

  const onChangeUserContent = (e) => {
    setUserContent(e.target.value);
  };

  const onChangeVarName = (e) => {
    setOutputVariable(e.target.value);
  };

  const findAndUpdate = (arr, id, payload) => {
    let found = arr.findIndex((i) => i.id == id);
    if (found > -1) {
      arr[found] = { ...arr[found], ...payload };
    } else {
      arr.forEach((element) => {
        if (
          [
            "branch",
            "condition",
            "loop",
            "loop-nodes",
            "try",
            "try-catch-node",
            "review",
            "review-node",
          ].includes(element.type)
        ) {
          findAndUpdate(element.children, id, payload);
        }
      });
    }
    return arr;
  };

  const handleSubmit = async () => {
    try {
      if (
        modelName == "" ||
        userContent == "" ||
        outputVariable == ""
      ) {
        dispatch(notify("error", "All fields are mandatory"));
      } else {
        let msgObj = [
          {
            role: "user",
            content: userContent,
          }
        ];
        nodeData["messages"] = msgObj;
        nodeData["collectionName"] = modelName;
        nodeData["variable"] = outputVariable;
        nodeData["org"] = userDetails?.id;
        nodeData["userType"] = planType;
        setNodeData(nodeData);
        let newActions = findAndUpdate(
          skill?.RAW_DATA?.actions,
          props?.data?.id,
          nodeData
        );

        store.dispatch(
          setDraft({
            ...skill,
            RAW_DATA: { ...skill?.RAW_DATA, actions: newActions },
          })
        );
        props?.updateConfig(nodeData, props?.data?.id);
        props?.closeDrawer();

        setNodeData(null);
        setModelName("");
        setUserContent("");
        setOutputVariable("");
      }
    } catch (err) {
      console.log("form error", err);
    }
  };

  const getCollectionsData = async () => {
    try {
      const data = orgFilterFlag ? await getCollections() : await getCollectionsV2();
      setCollections(data.response);
    } catch (err) {
      console.log("Error while retrieving", err.message);
    }
  };

  useEffect(() => {
    getCollectionsData();
  }, []);

  return (
    <Row className="chatgpt-row">
      <Col span={18}>        
        <div className="chg-message">
          <div className="chg-ip">
            <span>USER</span>
            <TextArea
              rows={6}
              placeholder="Enter your message here"
              onChange={onChangeUserContent}
              defaultValue={props?.data?.messages[0]?.content}
            ></TextArea>
          </div>
          <Button type="primary" onClick={handleSubmit}>
            Save
          </Button>
        </div>
      </Col>
      <Col span={6} className="config-items-outer">
        <div className="config-items">
          <div className="cnf-item">
            <label>Collections</label>
            <Select
              showSearch
              style={{
                width: "100%",
              }}
              placeholder="Search to Select"
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.label ?? "").includes(input)
              }
              filterSort={(optionA, optionB) =>
                (optionA?.label ?? "")
                  .toLowerCase()
                  .localeCompare((optionB?.label ?? "").toLowerCase())
              }
              options={collections.map((collection) => ({
                value: collection.name,
                label: orgFilterFlag ? collection.name : collection.name?.slice(collection.name.indexOf("_") + 1),
              }))}
              onChange={onChangeGptModal}
              defaultValue={props?.data?.collectionName}
            />
          </div>
          <div className="cnf-item">
            <label>Output Variable</label>
            <div className="cnf-slider">
              <Input
                defaultValue={props?.data?.variable}
                onChange={onChangeVarName}
              />
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default RagConfig;
